// src/Hero.js
import React, { useState, useRef } from 'react';
import './Hero.css';
import Navbar from './Navbar';
import Footer from './Footer';
import GypsyPage from './GypsyPage';
import Qualifications from './Qualifications';
import DarkMode from './pages/DarkMode';
import AccessibilityTools from './AccessibilityTools';

const Hero = () => {
  // hero background style
  const heroStyle = {
    background: `url(${process.env.PUBLIC_URL + '/picz/themes/J&V-345.jpg'}) no-repeat center center`,
    backgroundSize: 'cover',
    minHeight: '100vh',
//    backgroundColor: '#B19A7A',
//    backgroundColor: '#CBC0AB',
    textAlign: 'center',
    padding: '0'
  };
  

  return (
    <section id="home" className="hero-section" style={heroStyle}>
      <Navbar />
      <img src="/picz/bgr_pandemicRobot.png" alt="Vanessa L" className="v-class" style={{ width: '40vh' }}/>
      <Qualifications />
      <GypsyPage />
      <DarkMode />
      <AccessibilityTools />
      <Footer />
    </section>
  );
};

export default Hero;
